import type { PageProps } from 'gatsby';
import React from 'react';

import BigCircle from '@components/BigCircle';

import AdminManagement from '@views/Admin/Management';

export default function AdminOperationDrilldownPage({ params }: PageProps) {
  const { id: operation_id } = params;

  return (
    <AdminManagement.Layout maxContentWidth="md">
      <BigCircle />
      <AdminManagement.Operations.Drilldown operation_id={operation_id} />
    </AdminManagement.Layout>
  );
}
